// Single source of truth for join route paths.
// See docs/migration-rules.md §5.

export const JOIN_ROOT = '/join' as const

// ─── Join flow steps ─────────────────────────────────────────────────────
// Step order is data-driven (the VAT step is conditional on hasTaxStep), so
// these are addressed individually rather than as an ordered list.
export const JOIN_SELECT_OFFER = '/join/select-offer' as const
export const JOIN_TEAM_LEADER = '/join/team-leader' as const
export const JOIN_MY_DETAILS = '/join/my-details' as const
export const JOIN_VAT = '/join/vat' as const
export const JOIN_PAYMENT = '/join/payment' as const
export const JOIN_AGREEMENTS = '/join/agreements' as const
export const JOIN_CONFIRMATION = '/join/confirmation' as const

// The join root or one of its steps, with or without a sub-locale prefix (/fr, /de).
const JOIN_FLOW_PATH = /^(?:\/[a-z]{2})?\/join(?:\/|$)/

export const isJoinFlowPath = (path: string): boolean => JOIN_FLOW_PATH.test(path)
